import BtSupervisionTableRow from './BtSupervisionTableRow';
import { FTableContainer } from '../../../base';
import { skillAcquisitionData, skillAcquistionHeaderConfig } from './constants';

import type { IBtSupervision } from '../../../../utils/types';
interface SkillAcquisitionProps {
  isEditable: boolean;
  btSupervision: IBtSupervision;
  onUpdateValue: (key: string, value: string) => void;
}

function SkillAcquisition({ isEditable, btSupervision, onUpdateValue }: SkillAcquisitionProps) {
  return (
    <FTableContainer
      sx={{ mt: 3, borderRadius: '4px' }}
      headerStyle={{
        borderRadius: '4px 4px 0 0',
        pl: 3,
        px: 0,
      }}
      headerConfig={skillAcquistionHeaderConfig}
    >
      {skillAcquisitionData.map((item) => {
        return (
          <BtSupervisionTableRow
            key={item.id}
            value={item.label}
            headerConfig={skillAcquistionHeaderConfig}
            isEditable={isEditable}
            selectedValue={{
              key: item.key,
              value: btSupervision[item.key],
            }}
            onChange={onUpdateValue}
          />
        );
      })}
    </FTableContainer>
  );
}

export default SkillAcquisition;
